<header class="header">
  <div class="left-cell dark-text-small">
    <span>{{ getUtcOffset() }}</span>
  </div>

  <div
    *ngFor="let header of headers"
    class="main-cell dark-text-small"
    [class.empty]="!header"
  >
    <span *ngIf="!!header">
      {{ header }}
    </span>

    <div *ngIf="!header"></div>
  </div>

  <div class="right-stub"></div>
</header>
<ng-content></ng-content>
<div
  class="scrollable-container wbkt-scroll"
  #scrollableContainer
  (scroll)="onScroll($event)"
>
  <div class="grid-main-wrapper">
    <table class="layer bottom" cellpadding="0" cellspacing="0">
      <tbody>
        <tr height="1">
          <td class="row-left-stub"></td>
          <td [colSpan]="headers.length">
            <div class="row-markers-container">
              <div class="row-markers">
                <ng-template
                  ngFor
                  let-dayPart
                  let-i="index"
                  [ngForOf]="dayParts"
                  [ngForTrackBy]="trackById"
                >
                  <div
                    class="row-marker"
                    [class.dark]="i % 2 === 0"
                    [attr.id]="dayPart.id"
                    [class.end-of-view]="isEndOfView(i)"
                  >
                    <div class="row-dual-marker row-dual-marker-top"></div>
                    <div class="row-dual-marker row-dual-marker-bottom"></div>
                  </div>
                </ng-template>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <table
      class="layer upper"
      #containerTable
      cellpadding="0"
      cellspacing="0"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave($event, containerTable.getBoundingClientRect())"
      (drop)="onDrop($event)"
      [class.drag]="_dragMarkTop !== null"
    >
      <tbody>
        <tr>
          <td class="column-left">
            <div
              *ngFor="let dayPart of dayParts; let i = index"
              class="daypart-header"
              [class.end-of-view]="isEndOfView(i)"
              (click)="onDaypartClick($event, dayPart)"
              (contextmenu)="onDaypartRightClick($event, dayPart)"
              [class.zoom-in]="!zoomOutMode && canZoomIn()"
              [class.zoom-out]="zoomOutMode && canZoomOut()"
            >
              <div class="daypart-header-inner dark-text-small">
                {{ dayPart.text }}
              </div>
            </div>
          </td>
          <td
            class="column"
            *ngFor="let column of headers; let columnIndex = index"
            #column
          >
            <icn-calendar-video
              *ngFor="
                let video of calendarColumns[columnIndex];
                let videoIndex = index
              "
              [ngStyle]="{
                'top.px': video.topForColumn[columnIndex],
                'height.px': video.height,
              }"
              [currentView]="currentView"
              [video]="video"
              [index]="videoIndex"
              [contextMenu]="basicMenu"
              [contextMenuValue]="video"
              [class.video-drag]="video.isDragged || video.isDropped"
              [channelFramerate]="channelFramerate"
              [draggable]="video.items.length === 1"
              (dragStart)="video.items.length > 1 ? false : onVideoDrag($event)"
              (dragEnd)="onVideoDragEnd()"
              (durationAdjustDragStart)="durationAdjustShow = $event"
              (durationAdjustDragEnd)="durationAdjustShow = null"
              (dblclick)="onVideoClick(video)"
              (onClickVideoSubtitles)="
                onClickVideoSubtitles($event, subtitlesPopover)
              "
            >
            </icn-calendar-video>

            <div
              class="current-time-line"
              [ngStyle]="{
                display:
                  showLineAndTriangle() &&
                  ((isWeekView() && showLineWeekView(columnIndex)) ||
                    !isWeekView())
                    ? 'block'
                    : 'none',
                'top.px': currentIndicatorOffsetTop(),
              }"
            >
              <div></div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div
      class="drag-marker"
      [ngStyle]="{
        visibility: !!_dragMarkWidth ? 'visible' : 'hidden',
        'top.px': _dragMarkTop || 0,
        'left.px': _dragMarkLeft || 0,
        'width.px': _dragMarkWidth || '100%',
      }"
    >
      <div></div>
    </div>
    <div
      class="current-time-triangle"
      [ngStyle]="{
        display: showLineAndTriangle() ? 'block' : 'none',
        'top.px': currentIndicatorOffsetTop(),
      }"
    ></div>
  </div>
</div>
<div *ngIf="_isLoading" class="loader-bg-panel">
  <img src="/assets/loader3.svg" />
  <span>Loading Content</span>
</div>

<pop-over
  #subtitlesPopover
  [my]="'bottom right'"
  [at]="'top right'"
  [anchor-to]="true"
  [y-offset]="13"
>
  <icn-subtitles-popover
    [subtitles]="videoSubtitlesClicked ? videoSubtitlesClicked.subtitles : []"
    (close)="onSubtitlesClose(subtitlesPopover)"
  ></icn-subtitles-popover>
</pop-over>

<context-menu [menuClass]="'absolute-positioned'">
  <ng-template contextMenuItem let-item (execute)="removeVideo($event.value)">
    Remove from calendar
  </ng-template>
  <ng-template
    *ngFor="let script of getUserDynamicScripts()"
    contextMenuItem
    (execute)="onDynamicScriptClick($event.value, script)"
  >
    {{ script.displayName }}
  </ng-template>
  <ng-template contextMenuItem (execute)="closeGap($event.value)">
    Close gap
  </ng-template>
  <ng-template
    contextMenuItem
    let-item
    [visible]="isReplaceShowMenuVisible.bind(this)"
    (execute)="openReplaceShowModal($event.value)"
  >
    Replace show
  </ng-template>
  <ng-template contextMenuItem (execute)="openRenameModal($event.value)">
    Rename show
  </ng-template>
  <ng-template
    contextMenuItem
    let-item
    [visible]="isChooseSegmentMenuVisible.bind(this)"
    (execute)="chooseSegmentClickedEventHandler($event.value)"
  >
    Choose Segment
  </ng-template>
  <ng-template
    contextMenuItem
    (execute)="openChannelFuturePreview($event.value)"
  >
    Preview
  </ng-template>
  <ng-template
    let-item
    contextMenuItem
    (execute)="changeAnchorState($event.value)"
  >
    {{ showAnchorMenuItemText(item) }}
  </ng-template>
</context-menu>
